/**
 * Dynamically determine API URL based on current location
 * Supports both localhost and domain access
 */
export const getApiUrl = (): string => {
  // If REACT_APP_API_URL is explicitly set in .env, use it
  if (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL !== '') {
    console.log('Using REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL;
  }

  // Otherwise, dynamically construct based on current location
  const protocol = window.location.protocol; // http: or https:
  const hostname = window.location.hostname; // localhost, api.tungkt.com, etc.
  const port = window.location.port ? `:${window.location.port}` : ''; // :3000, :80, etc.

  console.log('Dynamic API URL detection:', { protocol, hostname, port });

  // Map frontend ports to backend ports
  let backendPort = '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // If frontend is on localhost:3000, backend is on localhost:5001
    backendPort = ':5001';
  } else {
    // For domain/production, keep same port as frontend (or empty for default)
    backendPort = '';
  }

  const apiUrl = `${protocol}//${hostname}${backendPort}`;
  console.log('Computed API URL:', apiUrl);
  return apiUrl;
};

export const API_URL = getApiUrl();

console.log('API URL detected:', API_URL);
